import React, { useState, useCallback } from "react";
import EditorLayout from "../../components/editor/EditorLayout";
import GenerationSidebar from "../../components/editor/left-sidebar/generation-sidebar";
import ColorSettingsSidebar from "../../components/editor/right-sidebar/color-settings-sidebar";
import TextSettingsSidebar from "../../components/editor/right-sidebar/text-settings-sidebar";
import UploadSettingsSidebar from "../../components/editor/right-sidebar/upload-settings-sidebar";
import Dashboard from "../../components/editor/dashboard/dashboard";

const EditorPage = () => {
  const [activeOverlay, setActiveOverlay] = useState("color");
  const [shouldAutoOpenUpload, setShouldAutoOpenUpload] = useState(false);

  const handleSetActiveOverlay = useCallback((overlay: string) => {
    setActiveOverlay((prev) => {
      if (overlay === "upload" && prev !== "upload") {
        setShouldAutoOpenUpload(true);
      }
      return overlay;
    });
  }, []);

  const handlePickerOpened = useCallback(() => {
    setShouldAutoOpenUpload(false);
  }, []);

  React.useEffect(() => {
    const handleTriggerUpload = () => {
      setActiveOverlay((prev) => {
        if (prev !== "upload") {
          setShouldAutoOpenUpload(true);
          return "upload";
        }
        return prev;
      });
    };
    window.addEventListener("trigger-upload-image", handleTriggerUpload);
    return () => window.removeEventListener("trigger-upload-image", handleTriggerUpload);
  }, []);

  const renderRightSidebar = () => {
    if (activeOverlay === "text") return <TextSettingsSidebar setActiveOverlay={handleSetActiveOverlay} />;
    if (activeOverlay === "upload") {
      return (
        <UploadSettingsSidebar
          setActiveOverlay={handleSetActiveOverlay}
          autoOpenPicker={shouldAutoOpenUpload}
          onPickerOpened={handlePickerOpened}
        />
      );
    }
    return <ColorSettingsSidebar setActiveOverlay={handleSetActiveOverlay} />;
  };

  return (
    <EditorLayout
      leftSidebar={<GenerationSidebar />}
      rightSidebar={renderRightSidebar()}
      rightSidebarClass={activeOverlay === "upload" ? "upload_active_sidebar" : ""}
    >
      <Dashboard activeOverlay={activeOverlay} />
    </EditorLayout>
  );
};

export default EditorPage;
